



































import { Component, Prop, Vue } from "vue-property-decorator";
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import { Sorteo } from '@/model/Sorteo';
import { DecimoService } from '@/services/DecimoService';

const STATUS_INITIAL = 0, STATUS_SAVING = 1;

@Component({
  components: {}
})
export default class SorteoActualizarNumerosPopup extends Vue {

  @Prop({ type: String, default: "ActualizarNumerosForm-Close" })
  nameEventClose: string | any;

  @Prop({ type: String, default: "ActualizarNumerosForm-Save" })
  nameEventSave: string | any;
  
  @Prop({ type: Boolean, default: false })
  visible: boolean = false;

  currentStatus: any = null;
  formData: any;
  fieldName: string = "";

  created() {
    logService.Info("Inicio","SorteoActualizarNumerosPopup.vue - created()");
    this.reset();
  }

  destroyed(){
    eventService.off(this.nameEventClose);
    eventService.off(this.nameEventSave);
  }

  close() {
    logService.Info("Inicio","SorteoActualizarNumerosPopup.vue - close()");
    eventService.emit(this.nameEventClose, null);
  }

  save() {
    logService.Info("Inicio","SorteoActualizarNumerosPopup.vue - save()");
    eventService.emit(this.nameEventSave, this.formData);
    this.reset();
  }

  isInitial() {
    return this.currentStatus === STATUS_INITIAL;
  }

  isSaving() {
    return this.currentStatus === STATUS_SAVING;
  }

  reset() {
    this.currentStatus = STATUS_INITIAL;
    this.fieldName = "";
    this.formData = null;
  }

  filesChange(fieldName: any, fileList: any) {
    const formData = new FormData();
    logService.Info("Inicio","SorteoActualizarNumerosPopup.vue - filesChange()");

    if (!fileList.length) return;

    if(fileList[0].name.search(".csv") !== -1){
      formData.append(fieldName, fileList[0], fileList[0].name)
      this.fieldName = fileList[0].name;
      this.formData = formData;
      this.currentStatus = STATUS_SAVING;
    }else{
      logService.Info("El archivo debe ser de tipo .csv","SorteoActualizarNumerosPopup.vue - filesChange()");
      toastService.warning("El archivo debe ser de tipo .csv");
      this.reset();
    }
  }
}
